import type {
  IApiResponse,
  UserPlayerSettingsSerializer,
  UserPlayerSettingsSaveSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

export const playerSettings = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getSettings: build.query<UserPlayerSettingsSerializer, number | undefined>({
      query(artId) {
        let url = "/foundation/api/users/me/settings/player";
        if (artId) {
          url += `?art_id=${artId}`;
        }
        return {
          url,
          method: "GET",
        };
      },
      transformResponse: (
        response: IApiResponse<UserPlayerSettingsSerializer>
      ) => {
        return response.payload.data;
      },
    }),
    setSettings: build.mutation<
      IApiResponse<UserPlayerSettingsSaveSerializer>,
      { artId: number; speed: number }
    >({
      query: ({ artId, speed }) => ({
        url: `/foundation/api/users/me/settings/player`,
        method: "PUT",
        body: {
          art_playback_speed: {
            art_id: artId,
            speed,
          },
        },
      }),
    }),
  }),
});
